/**
 * Componente de navegación de fechas para Control Semanal
 */

import React from 'react';
import { Row, Col, Card, Button } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';
import { formatDate } from '../utils/helpers';

const DateNavigator = ({ dateRange, onNavigate, canNavigateNext, loading }) => {
  return (
    <Card className="mb-4">
      <Card.Body>
        <Row className="align-items-center">
          <Col xs="auto">
            <Button
              variant="outline-primary"
              onClick={() => onNavigate('prev')}
              disabled={loading}
              title="Día anterior"
            >
              <FaIcons.FaChevronLeft />
            </Button>
          </Col>
          <Col>
            <div className="text-center">
              <h5 className="mb-1">
                Del {formatDate(dateRange.startDate)} al {formatDate(dateRange.endDate)}
              </h5>
              <small className="text-muted">
                {dateRange.startDate} - {dateRange.endDate}
              </small>
            </div>
          </Col>
          <Col xs="auto">
            <Button
              variant="outline-primary"
              onClick={() => onNavigate('next')}
              disabled={loading || !canNavigateNext}
              title="Día siguiente"
            >
              <FaIcons.FaChevronRight />
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default DateNavigator;
